import React from 'react';
import Progress from 'components/shared/progress/Progress';
import Alert from '@material-ui/lab/Alert';
import {
    deleteSupplier,
    getSuppliers,
} from '../../../../../core/modules/accounting/suppliers/actions';
import {
    Button,
    Grid
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import {
    history,
    route,
    ROUTE_SUPPLIERS_ADD,
    ROUTE_SUPPLIERS_EDIT,
} from '../../../../../core/routing/routing';
import { t } from '../../../../../core/i18n';
import { useList } from '../../../../../core/hooks/useList';
import { Add as AddIcon } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import BaseMaterialTable from '../../../../shared/table/BaseMaterialTable';
import { Collections } from 'core/networking/firebase';
import { useSelector } from 'react-redux';

const styles = () => ({
    addBtn: {
        marginBottom: 20,
    }
});

const SuppliersOverviewScene = ({ classes }) => {
    const workspaceId = useSelector(state => state.app.workspace);
    const { items, isLoading, error, refreshList, canSoftDelete, canDelete, canEdit } = useList(
        getSuppliers, Collections.suppliers
    );

    const headCells = [
        {
            id: 'name',
            title: t('suppliers.fields.name'),
            field: 'name',
            render: rowData => rowData.name,
        },
    ];

    const menuActions = [
        {
            action: 'edit',
            to: ROUTE_SUPPLIERS_EDIT,
            routeParam: 'id',
            routeParamExtra: { workspaceId: workspaceId }
        },
        {
            action: 'delete',
        },
        {
            action: 'deleteForever',
        },
        {
            action: 'restoreDelete',
        },
    ]

    const handleRowClick = (event, rowData) => {
        history.push(route(ROUTE_SUPPLIERS_EDIT, { workspaceId, id: rowData.id }))
    };

    if (isLoading) {
        return <Progress isLoading={isLoading} />;
    } else {
        return (
            <>
                {error && <Alert severity="error">{error}</Alert>}
                {items && (
                    <>
                        <Grid
                            container
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >
                            <Button
                                component={Link}
                                variant="contained"
                                color="primary"
                                className={classes.addBtn}
                                startIcon={<AddIcon />}
                                to={route(ROUTE_SUPPLIERS_ADD, { workspaceId })}>
                                {t('suppliers.add')}
                            </Button>
                        </Grid>
                        <BaseMaterialTable
                            title={t('suppliers.title')}
                            headCells={headCells}
                            items={items}
                            canEdit={canEdit}
                            canSoftDelete={canSoftDelete}
                            canDelete={canDelete}
                            deleteItemFunc={deleteSupplier}
                            menuActions={menuActions}
                            refreshList={refreshList}
                            collection={Collections.suppliers}
                            handleRowClick={handleRowClick}
                        />
                    </>
                )}
            </>
        );
    }
};

export default withStyles(styles)(SuppliersOverviewScene);
